/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Spaces_Wizard_Step2_Connect_ButtonInputs */



/**
* | output |
* | --- |
* | "Connect {provider}" |
*
* @param {Spaces_Wizard_Step2_Connect_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step2_connect_button = /** @type {((inputs: Spaces_Wizard_Step2_Connect_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step2_Connect_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.provider} verbinden`)
	return /** @type {LocalizedString} */ (`Connect ${i?.provider}`)
});